<template>
  <section class="container mb-md-5">
    <Title class="my-5" title="سوالی بپرسید؟!"></Title>
    <section class="questions-grid">
      <div class="text-center mt-md-5 order-md-0 order-1">
        <div class="d-md-block d-none">
          <svg class="icon" width="50" height="50">
            <use href="@/assets/svgIcons/svgIcons.svg/#brush"></use>
          </svg>
        </div>
        <h6
          class="fontsize-xheavy text-center text-color-444 my-5 d-md-block d-none"
        >
          سوالات پرتکرار
        </h6>
        <div>
          <button
            class="question-btn btn-hover-bulgy rounded-pill fontsize-medium weight-light py-2 px-3"
            data-toggle="modal"
            data-target="#exampleModal"
          >
            سوالی بپرسید؟
          </button>
        </div>
        <!-- Modal -->
        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog">
            <div class="modal-content">
              <div
                class="modal-header d-flex justify-content-between border-bottom-0"
              >
                <h5 class="modal-title" id="exampleModalLabel">
                  سوال خود را بپرسید..؟
                </h5>
                <button
                  ref="Close"
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span class="fontsize-large" aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <textarea
                  placeholder="سوال خود را در این قسمت وارد کنید"
                  v-model="question"
                  id="questionInput"
                  name=""
                  cols="30"
                  rows="10"
                ></textarea>
                <p id="alertBox" v-if="showAlert">{{ alertMessage }}</p>
                <button
                  class="btn-hover-bulgy question-btn"
                  id="sendQuestionButton"
                  @click="sendQuestion()"
                >
                  ارسال
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <CommonQuestions
        :data="data.faqs"
        class="order-md-1 order-0"
      ></CommonQuestions>
    </section>
  </section>
</template>

<script>
import Title from "./Title";
import CommonQuestions from "./CommonQuestions";
export default {
  name: "Questions",
  props: {
    data: Object
  },
  data() {
    return {
      alertMessage: "لطفا سوال خود را کامل تر وارد کنید",
      showAlert: false,
      question: ""
    };
  },
  components: {
    Title,
    CommonQuestions
  },
  methods: {
    sendQuestion() {
      if (this.question.length < 10) {
        this.showAlert = true;
      } else {
        this.showAlert = false;
        const formData = new FormData();
        formData.append("question", this.question);
        formData.append("type", "main");
        this.$axios.post("/faq",formData).then((response) => {
          console.log(response);
          const options = { title: "سپاس از شما", size: "sm" };
          this.$dialogs.alert("سوال شما دریافت شد", options);
          this.$refs.Close.click();
        });
      }
    }
  }
};
</script>

<style scoped>
.questions-grid {
  display: grid;
  grid-template-columns: minmax(50px, 2fr) minmax(50px, 5fr);
  grid-gap: 1rem;
}
.question-btn {
  width: 80%;
  background-color: var(--color-theme);
  color: white;
  border: 1px solid var(--color-theme);
}
.question-btn:hover {
  background: none;
  color: var(--color-theme);
}
.modal-header .close {
  margin: 0;
  padding: 0;
}
@media screen and (max-width: 767px) {
  .questions-grid {
    grid-template-columns: 1fr;
  }
  .question-btn {
    width: auto;
    padding-right: 30px !important;
    padding-left: 30px !important;
  }
}
textarea#questionInput {
  width: 90%;
  margin: auto;
  resize: none;
  border-radius: 10px;
  box-shadow: 0 0 4px #30504f;
  margin: auto;
  display: block;
  padding: 15px;
}
button#sendQuestionButton {
  width: 40%;
  padding: 15px;
  border-radius: 15px;
  margin: 30px auto;
}
p#alertBox {
  margin: 10px auto;
  color: #ff0000;
  text-shadow: 0 0 10px #00000094;
}
</style>
